import { Page } from '@/types/Page'
import { WithDefaultLayout } from '@/components/DefautLayout'
import React , { useState, useEffect } from 'react';
import { certificates } from '@/constants/certificate';
import { Dropdown, Button, MenuProps } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Certificate = () => {

  const [activeTab, setActiveTab] = useState("All");
  const [searchNumber, setSearchNumber] = useState("");
  const [searchName, setSearchName] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [year, setYear] = useState<number>(2026);
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

    const Tabs: string[] = ["All", "Competitive Programming", "Scratch Coding Game", "EcoQuest Web Application", "Innovative Technology Challenge"];

  const filteredData = certificates.filter((cert) => {
    const certYear = new Date(cert.date).getFullYear();
    if (activeTab !== "All" && cert.category !== activeTab) return false;
    if (certYear !== year) return false;
    if (
      activeTab &&
      activeTab !== "All" &&
      cert.category !== activeTab
    )
      return false;
    const matchNumber = cert.number
    .toLowerCase()
    .includes(searchNumber.toLowerCase());

    const matchName = cert.name
    .toLowerCase()
    .includes(searchName.toLowerCase());

    return matchNumber && matchName;
  });

  const sortedData = [...filteredData].sort((a, b) => {
  if (sortColumn === "name") {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    return sortOrder === "asc"
      ? nameA.localeCompare(nameB)
      : nameB.localeCompare(nameA);
  }

  if (sortColumn === "number") {
  const getNumber = (value: string) => {
    const parts = value.split("/");
    return parseInt(parts[0] || "0", 10);
  };

  const numA = getNumber(a.number);
  const numB = getNumber(b.number);

  return sortOrder === "asc" ? numA - numB : numB - numA;
  }



  return 0;
  });

  const handleSort = (column: string) => {
  if (sortColumn === column) {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  } else {
    setSortColumn(column);
    setSortOrder("asc");
  }
  };

  const formatDate = (dateStr: string) => {
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
  };


  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const paginatedData = sortedData.slice(startIndex, startIndex + entriesPerPage);


  const handleMenuClick: MenuProps["onClick"] = (e) => {
      setYear(parseInt(e.key));
    };
  
    const items: MenuProps["items"] = [
      {
        key: "2024",
        label: <a>2024</a>,
      },
      // {
      //   key: "2025",
      //   label: <a>2025</a>,
      // },
      {
        key: "2026",
        label: <a>2026</a>,
      },
    ];

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, searchNumber, searchName, entriesPerPage]);

  return (
    <div className="bg-gradient-to-b from-[#B3E5FC] to-white overflow-hidden">
      <div className="w-full max-w-6xl mx-auto px-4 mt-10">
        <h1 className="text-3xl md:text-4xl font-bold font-body text-center text-[#015C92] mb-8">
          <span className="md:whitespace-nowrap">Certificate Winners List - </span>
          <span className="inline-flex items-center space-x-1">
            <span>{year}</span>
            <Dropdown menu={{ items, onClick: handleMenuClick }} trigger={["click"]}>
              <Button
              className="text-white font-bold w-6 h-6 flex items-center justify-center bg-defaultBlue hover:bg-darkBlue border-0"
              icon={<FontAwesomeIcon icon={faChevronDown} style={{ fontSize: "0.75rem" }} />}
              />
            </Dropdown>
          </span>
        </h1>

        <div className="flex justify-center gap-4 mb-6 flex-wrap font-body">
          {Tabs.map((sub) => (
            <button
              key={sub}
              onClick={() => setActiveTab(sub)}
              className={`px-4 py-2 rounded font-medium border shadow-sm transition ${
                activeTab === sub
                  ? "bg-[#1E3A8A] text-white border-[#0284C7]"
                  : "bg-white text-[#0277BD] border-[#81D4FA] hover:bg-[#E1F5FE]"
              }`}
            >
              {sub}
            </button>
          ))}
        </div>

        <div className="bg-white shadow-md rounded-lg p-4 mb-6 flex flex-col md:flex-row gap-4 justify-between">
          <div className="flex flex-col w-full md:w-1/2">
            <label
              htmlFor="number"
              className="text-gray-700 font-body font-semibold mb-2"
            >
              Number
            </label>
            <input
              id="number"
              type="text"
              value={searchNumber}
              onChange={(e) => setSearchNumber(e.target.value)}
              placeholder="Enter number..."
              pattern="[A-Za-z0-9-]+"
              title="Only letters, numbers, and hyphens (-) are allowed"
              className="border border-gray-300 rounded-md font-body p-2 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            />
          </div>

          <div className="flex flex-col w-full md:w-1/2">
            <label
              htmlFor="name"
              className="text-gray-700 font-body font-semibold mb-2"
            >
              Full Name
            </label>
            <input
              id="name"
              type="text"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              placeholder="Enter full name..."
              className="border border-gray-300 rounded-md font-body p-2 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            />
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
          <div className="flex items-center gap-2 text-gray-700 font-body">
            <span>Show</span>
            <select
              value={entriesPerPage}
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
              className="border border-gray-300 rounded-md px-2 py-1 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            >
              {[5, 10, 15, 25].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span>entries</span>
          </div>
        </div>

        {/* Desktop Table */}
        <div className="bg-white shadow-lg rounded overflow-hidden">
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm text-gray-700 border-collapse">
              <thead className="bg-[#1E3A8A] text-white font-body">
                <tr>
                  <th 
                    className="px-4 py-3 text-left cursor-pointer select-none"
                    onClick={() => handleSort("number")}
                  >
                    <div className="flex items-center gap-1">
                      Number
                      <span className="flex flex-col leading-none">
                        <span className={sortColumn === "number" && sortOrder === "asc" ? "opacity-100" : "opacity-30"}>
                          ▲
                        </span>
                        <span className={sortColumn === "number" && sortOrder === "desc" ? "opacity-100" : "opacity-30"}>
                          ▼
                        </span>
                      </span>
                    </div>
                  </th>
                  <th 
                    className="px-4 py-3 text-left cursor-pointer select-none"
                    onClick={() => handleSort("name")}
                  >
                    <div className="flex items-center gap-1">
                      Full Name
                      <span className="flex flex-col leading-none">
                        <span className={sortColumn === "name" && sortOrder === "asc" ? "opacity-100" : "opacity-30"}>
                          ▲
                        </span>
                        <span className={sortColumn === "name" && sortOrder === "desc" ? "opacity-100" : "opacity-30"}>
                          ▼
                        </span>
                      </span>
                    </div>
                  </th>
                  <th className="px-4 py-3 text-left">Category</th>
                  <th className="px-4 py-3 text-left whitespace-nowrap">Study Level</th>
                  <th className="px-4 py-3 text-left whitespace-nowrap">
                    Release Date
                  </th>
                  <th className="px-4 py-3 text-left whitespace-nowrap">
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((cert, index) => (
                    <tr
                      key={index}
                      className={`border-b font-body ${
                        index % 2 === 0 ? "bg-gray-50" : "bg-white"
                      }`}
                    >
                      <td className="px-4 py-3 font-semibold text-gray-800">
                        {cert.number}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800 ">
                        {cert.name}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800 whitespace-nowrap">
                        {cert.category}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800">
                      {cert.StudyLevel || "-"}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800">
                        {formatDate(cert.date)}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800 whitespace-nowrap">
                      {cert.Note || "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      className="text-center text-gray-500 py-5 italic"
                    >
                      No matching data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="block md:hidden p-4">

            {/* Mobile Sorting */}
            <div className="mb-4 bg-white border rounded-lg p-3 shadow-sm">
              <h2 className="text-base text-center font-body font-semibold text-gray-700 mb-2">
                Sort Options
              </h2>

              <label className="text-gray-600 font-body text-sm mb-1 block">
                Sort by Number
              </label>
              <select
              className="w-full border border-gray-300 rounded-md p-2 mb-2"
              value={sortColumn === "number" ? sortOrder : ""}
              onChange={(e) => {
              setSortColumn("number");
              setSortOrder(e.target.value as "asc" | "desc");
              }}
              >
              <option value="">Select Order</option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
              </select>

              <label className="text-gray-600 font-body text-sm mb-1 block">
                Sort by Name
              </label>
              <select
              className="w-full border border-gray-300 rounded-md p-2 mb-2"
              value={sortColumn === "name" ? sortOrder : ""}
              onChange={(e) => {
              setSortColumn("name");
              setSortOrder(e.target.value as "asc" | "desc");
              }}
              >
              <option value="">Select Order</option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
              </select>

            </div>

            {paginatedData.length > 0 ? (
              <div className="grid grid-cols-1 gap-4">
                {paginatedData.map((cert, index) => (
                  <div
                    key={index}
                    className="border-4 border-[#0284C7] rounded-lg shadow-sm p-4 bg-gray-50"
                  >
                    <p className="text-sm text-gray-500 mb-1 font-semibold">Number</p>
                    <p className="font-semibold">{cert.number}</p>

                    <p className="text-sm text-gray-500 mt-2 mb-1 font-semibold">Full Name</p>
                    <p className="font-semibold">{cert.name}</p>

                    <p className="text-sm text-gray-500 mt-2 mb-1 font-semibold">
                      Category
                    </p>
                    <p className="font-semibold">{cert.category}</p>
                    
                    <p className="text-sm text-gray-500 mt-2 mb-1 font-semibold">
                      Study Level
                    </p>
                    <p className="font-semibold">{cert.StudyLevel || "-"}</p>
                    <p className="text-sm text-gray-500 mt-2 mb-1 font-semibold">
                      Release Date
                    </p>
                    <p className="font-semibold">
                      {formatDate(cert.date)}
                    </p>
                    <p className="text-sm text-gray-500 mt-2 mb-1 font-semibold">
                      Description
                    </p>
                    <p className="font-semibold">{cert.Note || "-"}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-500 italic py-5">
                No matching data found.
              </p>
            )}
          </div>
        </div>

        {/* Footer Pagination */}
        <div className="flex flex-col md:flex-row justify-between items-center mt-6 font-body text-sm text-gray-700">
          <div className="text-gray-600 mb-3 md:mb-0">
            Showing{" "}
            {filteredData.length === 0
              ? 0
              : (currentPage - 1) * entriesPerPage + 1}{" "}
            to {Math.min(currentPage * entriesPerPage, filteredData.length)} of{" "}
            {filteredData.length} entries
          </div>

          <div className="flex items-center space-x-1">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded-md border text-sm ${
                currentPage === 1
                  ? "text-gray-400 border-gray-300 cursor-not-allowed"
                  : "text-teal-700 border-gray-300 hover:bg-teal-100"
              }`}
            >
              Previous
            </button>

            {[...Array(totalPages)].slice(0, 5).map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={`px-3 py-1 rounded-md border text-sm ${
                  currentPage === i + 1
                    ? "bg-[#1E3A8A] text-white"
                    : "text-gray-700 border-gray-300 hover:bg-teal-100"
                }`}
              >
                {i + 1}
              </button>
            ))}

            {totalPages > 5 && <span className="px-2">...</span>}

            <button
              onClick={() =>
                setCurrentPage((prev) =>
                  prev < totalPages ? prev + 1 : totalPages
                )
              }
              disabled={currentPage === totalPages || totalPages === 0}
              className={`px-3 py-1 rounded-md border text-sm ${
                currentPage === totalPages || totalPages === 0
                  ? "text-gray-400 border-gray-300 cursor-not-allowed"
                  : "text-teal-700 border-gray-300 hover:bg-teal-100"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const Render = () => {
    return (
        <div className='-mb-16'>
            <Certificate />
        </div>
  );
}

const iitCertificate: Page = () => {
    return (
        <div>
            {Render()}
        </div>
    )
}

iitCertificate.layout = WithDefaultLayout;
export default iitCertificate;